const paradomAdminConsoleTag = 'paradom_admin_console';

export const SPLIT_CONSTANTS = {
    SPLIT_USER_CONVERSION_DATA: paradomAdminConsoleTag + '_user_conversion_data',
    SPLIT_MAINTENANCE_PAGE: 'paradome_maintenance_page',
    SPLIT_PIXEL_GUARD_V2: 'paradome_pixel_guard_v2',
    SPLIT_HIDE_DATA_EXPORTS_LINK: 'PR_HIDE_DATA_EXPORTS_LINK',
    AC_ACCOUNT_SETTINGS: 'AC_ACCOUNT_SETTINGS',
    PD_UPLOADED_REPORTS: 'PD_UPLOADED_REPORTS',
    PD_AGENT_INTENT_REBRAND: 'PD_AGENT_INTENT_REBRAND',
    // Toggled per network from the account view; see FeatureFlagsService. https://cheqai.atlassian.net/browse/PAR-8199
    PARADOME_MARKETING_SECURITY: 'PARADOME_MARKETING_SECURITY',
    // Wrapper around the toggle above: OFF (default) => the Marketing Security control is not rendered at all.
    PARADOME_MARKETING_SECURITY_WRAPPER_FLAG: 'PARADOME_MARKETING_SECURITY_WRAPPER_FLAG',
    // Kill-switch: ON => revert main-tag fetch to legacy cheq-api get_main_tag; OFF (default) => cq-accounts admin mount.
    ADMIN_MAIN_TAG_LEGACY_FALLBACK: paradomAdminConsoleTag + '_main_tag_legacy_fallback',
};
